/**
 * AP Uniforms — Product Color Map
 * Master swatch mapping system with 25 color groups from Arthur (#115/#116).
 * Each group has an approved hex value and aliases that resolve to it.
 * Case-insensitive lookup via normalize().
 */
var AP_COLOR_MAP = (function() {

  // ===================================================================
  // MASTER COLOR GROUPS — 24 groups (#150, based on #115/#116 + hex audit)
  // Each group: { name, hex, aliases[] }
  // Aliases are normalized (lowercase, trimmed, vendor codes stripped).
  // Reference: 06 Reference/color-groups-master.md
  //
  // ⚠ DUAL SOURCE OF TRUTH — see #249 ⚠
  // The header nav color grid is also rendered statically in Liquid (so
  // Googlebot's HTML pass sees the anchors). When adding/removing/renaming
  // a color group below, update the parallel snippet IN THE SAME COMMIT:
  //   apps/shopify-theme-usv4/snippets/nav-color-grid.liquid
  // ===================================================================
  var masterGroups = [
    // collection: URL for header nav link. null = no collection page yet (excluded from nav).
    { name: 'Black', hex: '#000000', collection: '/collections/black-scrubs', aliases: [
      'black', 'black on black', 'heather black',
      'black peach blossom', 'black/white stripe', 'bl/wm stripe'
    ]},
    { name: 'Navy', hex: '#000050', collection: '/collections/navy-scrubs', aliases: [
      'true navy blue', 'navy/ceil',
      'navy', 'true navy', 'real navy', 'pure navy', 'heather navy',
      'indigo blue', 'indigo', 'cobalt', 'imperial blue', 'navy blue',
      'navy-nvy',
      'ocean abyss'
    ]},
    { name: 'Ceil Blue', hex: '#8090B8', collection: '/collections/ceil-blue-scrubs', aliases: [
      'ceil blue', 'ceil', 'ceileste', 'ciel blue', 'blue',
      'heather ceil',
      'ciel'
    ]},
    { name: 'Pewter', hex: '#625D64', collection: '/collections/gray-scrubs', aliases: [
      'pewter', 'silver', 'iron', 'real pewter', 'dark pewter', 'charcoal', 'graphite',
      'steel', 'gray', 'grey', 'heather grey', 'heather light gray',
      'heather pewter', 'quiet grey', 'taylor grey', 'metallic silver',
      'light grey',
      'moonstone',
      'sea fog',
      'cloud',
      'heather ash',
      'heather gray',
      'silver stone'
    ]},
    { name: 'Royal Blue', hex: '#2855C5', collection: '/collections/royal-blue-scrubs', aliases: [
      'new royal', 'royal/lime',
      'royal blue', 'royal', 'galaxy blue', 'galaxy', 'heather royal',
      'regal blue', 'pacific blue',
      'galaxy print',
      'hyper blue'
    ]},
    { name: 'Hunter Green', hex: '#2B5030', collection: '/collections/hunter-green-scrubs', aliases: [
      'forest green',
      'hunter', 'hunter green', 'true hunter', 'mountain view', 'lush green',
      'pine green', 'pine',
      'hunter print',
      'nu green',
      'dark pine'
    ]},
    { name: 'Teal Blue', hex: '#038B96', collection: '/collections/teal-scrubs', aliases: [
      'teal', 'teal blue', 'surgical green', 'real teal',
      'heather caribbean',
      'sparkling jade',
      'teal tonic'
    ]},
    { name: 'Sky Blue', hex: '#70B8E8', collection: '/collections/sky-blue-scrubs', aliases: [
      'light chambray',
      'sky blue', 'ethereal blue', 'chambray blue',
      'ceylon blue', 'lyons blue',
      'glacier blue',
      'azure blue',
      'blue mist',
      'fresh blue',
      'rainwater',
      'trade winds'
    ]},
    { name: 'Aqua Blue', hex: '#48C8E0', collection: '/collections/aqua-blue-scrubs', aliases: [
      'aqua blue', 'aqua', 'maui blue', 'malibu blue',
      'cyan blue', 'aquamarine', 'lake blue', 'turquoise', 'arctic aqua',
      'crystal beach',
      'mint condition',
      'ocean breeze'
    ]},
    { name: 'Postman Blue', hex: '#5A7A90', collection: '/collections/postman-blue-scrubs', aliases: [
      'postman blue', 'infinity blue', 'slate blue', 'mykonos',
      'atlantic blue', 'ocean wave', 'peacock blue',
      'soft marine',
      'mineral blue',
      'vintage blue',
      'heritage blue',
      'mali-blu',
      'blue jean baby',
      'mali-blue shore',
      'spectra blue',
      'twilight blue'
    ]},
    { name: 'Lavender', hex: '#B8A0D0', collection: '/collections/lavender-scrubs', aliases: [
      'lavender', 'orchid bouquet', 'orchid bloom', 'light mauve',
      'purple freesia',
      'chilled lilac',
      'bright violet',
      'electric lavender',
      'orchid',
      'peri',
      'pretty n purple',
      'cyber violet',
      'digital lavender',
      'lilac',
      'meta mauve',
      'periwinkle',
      'persian violet',
      'purple surge'
    ]},
    { name: 'Eggplant', hex: '#4A2540', collection: '/collections/eggplant-scrubs', aliases: [
      'eggplant', 'purple', 'true purple', 'grape', 'dahlia',
      'ultra violet', 'deep purple', 'mulberry',
      'black sugar plum', 'sugar plum black', 'electric purple',
      'sugar plum', 'grape print', 'sugar plum/black',
      'deep amethyst',
      'galactic purple',
      'plum royale',
      'plum violet',
      'true grape',
      'plumberry'
    ]},
    { name: 'White', hex: '#F0F0E8', collection: '/collections/white-scrubs', aliases: [
      'white', 'white twill', 'white 6 oz polycotton twill',
      'white 8 oz 100% cotton twill', 'white with black trim',
      'light gray',
      'dove white',
      'white gardenia'
    ]},
    { name: 'Caribbean Blue', hex: '#4A7A8E', collection: '/collections/caribbean-blue-scrubs', aliases: [
      'carribean',
      'caribbean blue', 'caribbean',
      'caribbean print',
      'capri sea'
    ]},
    { name: 'Wine', hex: '#722F37', collection: '/collections/wine-scrubs', aliases: [
      'wine', 'heather wine', 'raspberry coulis', 'tea berry',
      'pickled beet', 'burgundy',
      'redwood dust',
      'heather cranberry',
      'cherry wine',
      'elderberry',
      'garnet red'
    ]},
    { name: 'Pink', hex: '#D8A0B0', collection: '/collections/pink-scrubs', aliases: [
      'rose blush',
      'pink', 'strawberry pink', 'hot pink', 'watermelon',
      'wild rose', 'rose violet', 'bella rosa',
      'bright rose', 'rose pink', 'candy pink', 'blush pink',
      'pink flash', 'passion pink', 'rose',
      'alloy pink', 'dancing blossom', 'hollyhock',
      'electric pink', 'slate rose',
      'raspberry', 'fuchsia',
      'peach blossom black', 'peach blossom',
      'pink sherbet', 'rose quartz', 'flamingo',
      'tropical hibiscus', 'soft pomegranate',
      'pink essence',
      'pink melon',
      'sweet berry',
      'azalea',
      'carmine pink',
      'future fuchsia',
      'pink blush',
      'pinkerton',
      'rapture rose',
      'shocking pink',
      'aurora berryalis',
      'back to the fuschia',
      'ballet slipper',
      'blushing peach',
      'carnation pink',
      'gumdrop',
      'ice pink',
      'perfectly pink',
      'pink pearl',
      'pink popsicle',
      'pink power',
      'pink punch',
      'pixel pink',
      'powder puff pink',
      'precious pink',
      'raspberry tart',
      'taffy pink'
    ]},
    { name: 'Khaki', hex: '#C3B091', collection: '/collections/khaki-scrubs', aliases: [
      'khaki', 'summer sand', 'sandstone', 'taupe', 'brown', 'chocolate', 'tender rose',
      'sandstone print',
      'espresso',
      'bronze mist',
      'dark khaki',
      'heather blonde wood',
      'heather clay',
      'gold rush',
      'caramel cafe',
      'dark chocolate',
      'desert taupe',
      'french brown',
      'midsummer gold',
      'sand dunes',
      'santa fe tan',
      'walnut roast'
    ]},
    { name: 'Red', hex: '#C01030', collection: '/collections/red-scrubs', aliases: [
      'red', 'true red', 'cherries jubilee', 'racing red',
      'crimson', 'cherry red',
      'true red print',
      'sweet paprika',
      'cherry pop'
    ]},
    { name: 'Aruba Blue', hex: '#48B8C8', collection: '/collections/aruba-blue-scrubs', aliases: [
      'aruba blue', 'island blue', 'scuba blue', 'heather island blue'
    ]},
    { name: 'Yellow', hex: '#D4B800', collection: '/collections/yellow-scrubs', aliases: [
      'yellow', 'sunshine', 'citron', 'illuminate', 'lemon drop', 'primrose', 'freesia',
      'dandelion',
      'copa banana',
      'sunray yellow',
      'butterscotch'
    ]},
    { name: 'Olive', hex: '#6B8E23', collection: '/collections/olive-scrubs', aliases: [
      'olive', 'olive branch', 'olive moss', 'moss',
      'terrain',
      'desert cactus'
    ]},
    { name: 'Green', hex: '#50C880', collection: '/collections/green-scrubs', aliases: [
      'green', 'patina green', 'opal', 'mint julep', 'heather mint julep',
      'cool mint', 'honeydew', 'mint', 'apple green', 'lime',
      'acid lime', 'apple',
      'celery green',
      'cucumber',
      'fern green',
      'aloe',
      'botanical green',
      'celadon',
      'lime green',
      'lime time',
      'acadia green',
      'beyond green',
      'cyber lime',
      'kiwi lime',
      'retro lime',
      'surreal green',
      'wasabi'
    ]},
    { name: 'Orange', hex: '#E8A080', collection: '/collections/coral-scrubs', aliases: [
      'papaya',
      'orange', 'coral', 'fresh salmon', 'deep coral',
      'coral sunset', 'coral pop', 'living coral', 'desert coral',
      'desert flower', 'peony pink',
      'tango', 'sunset',
      'papaya juice',
      'apricot orange',
      'ginger glow',
      'orange sorbet',
      'orange sunrise',
      'spiced coral',
      'apricot sorbet',
      'coral fusion',
      'one in a melon',
      "papa don't peach",
      'solar flare',
      'velvet peach',
      'warm sunrise'
    ]},
    { name: 'Sage', hex: '#9DB5AD', collection: '/collections/sage-scrubs', aliases: [
      'sage', 'seagrass', 'sea mist', 'mystic violet',
      'sage green'
    ]}
  ];

  // Build alias → hex lookup from masterGroups for O(1) resolution
  var aliasMap = {};
  for (var g = 0; g < masterGroups.length; g++) {
    var group = masterGroups[g];
    for (var a = 0; a < group.aliases.length; a++) {
      aliasMap[group.aliases[a]] = group.hex;
    }
  }

  // ===================================================================
  // INDIVIDUAL COLOR OVERRIDES
  // Colors that need a specific hex different from their master group.
  // These override aliasMap for individual swatch accuracy while still
  // belonging to a master group for filtering purposes.
  // ===================================================================
  var overrides = {
    // Infinity Footwear multi-color sock colorways (#334 CBI) — dominant color
    // so the swatch is a clean solid circle instead of the rainbow fallback.
    'black/vivid orange': '#1A1A1A',
    'black/white': '#1A1A1A',
    'black/grey/white': '#1A1A1A',
    'white/black': '#FFFFFF',
    'white/vivid orange': '#FFFFFF',
    'white/shocking pink': '#FFFFFF',
    'hyper yellow/turquoise': '#D4E82A',
    'vapor/firebird red': '#C0392B',
    'gold/pewter': '#C9A227',
    'purple/black/white': '#6D4AA7',
    'pewter/lavender': '#9A9AA0',
    'ruby pink/black/white': '#C51D5A',
    'sky blue/white/vivid orange': '#87CEEB',
    'pride': '#6D4AA7',

    // Black variants
    'black on black': '#1A1A1A',
    'heather black': '#303030',

    // Navy variants — different shades within navy family
    'heather navy': '#283848',
    'cobalt': '#0047AB',
    'indigo blue': '#3050A0',
    'imperial blue': '#2848A0',

    // Ceil variants
    'ceileste': '#8098C0',

    // Pewter/Grey variants — different shades
    'dark pewter': '#4A4548',
    'charcoal': '#383838',
    'graphite': '#505050',
    'steel': '#6A7080',
    'gray': '#808080',
    'grey': '#808080',
    'heather grey': '#909090',
    'heather light gray': '#B8B8B8',
    'heather pewter': '#8A8A78',
    'quiet grey': '#A0A0A0',
    'light gray': '#C0C0C0',
    'metallic silver': '#C0C0C0',

    // Royal variants
    'galaxy blue': '#1B3D6F',
    'galaxy': '#1B3D6F',
    'heather royal': '#3860A8',

    // Hunter Green variants
    'mountain view': '#3A6048',
    'lush green': '#008070',

    // Wave 4 additions — 2026-05-07. CA 3PL MAY 6 2026 sheet, rows 760-1839
    // (GH issue #285). Solid colors. Originally placed in `prints` by mistake;
    // moved to overrides 2026-05-10 because most are master-group aliases and
    // were resolving to the wrong hex via aliasMap (e.g. nu green → #6DC87A
    // Hunter Green default instead of the lighter #9FB85C).
    'plumberry': '#5C2C3D',
    'sunset': '#D8693C',
    'freesia': '#E5B912',
    'mystic violet': '#8B7AA8',
    'nu green': '#6DC87A',
    'rose quartz': '#F7CAC9',
    'flamingo': '#F08080',
    'burgundy': '#722F37',

    // Teal variants
    'teal blue': '#007888',
    'surgical green': '#007060',
    'real teal': '#008898',

    // Sky Blue variants
    'ethereal blue': '#A8C8E0',
    'opal': '#A0C0C8',

    // Aqua Blue variants
    'maui blue': '#4890E0',
    'malibu blue': '#00C8F8',
    'pacific blue': '#1CA9C9',
    'cyan blue': '#0098C8',
    'lake blue': '#00C8E0',
    'turquoise': '#30D5C8',

    // Postman Blue variants
    'slate blue': '#6888A0',
    'mykonos': '#1E90C8',
    'atlantic blue': '#3070A0',
    'ocean wave': '#3080A0',
    'peacock blue': '#0070A0',

    // Lavender variants
    'orchid bouquet': '#B078A8',
    'orchid bloom': '#B868A0',
    'light mauve': '#D0A8B0',

    // Eggplant/Purple variants (#150: hollyhock moved to Pink)
    'purple': '#6A0070',
    'true purple': '#6A0070',
    'grape': '#5B2C6F',
    'dahlia': '#803080',
    'ultra violet': '#6B28A0',
    'deep purple': '#4B0082',
    'mulberry': '#A08098',
    'black sugar plum': '#2A1028',
    'sugar plum black': '#2A1028',
    'black peach blossom': '#2A1018',

    // White variants
    'white twill': '#F5F5F0',
    'white 6 oz polycotton twill': '#F5F5F0',
    'white 8 oz 100% cotton twill': '#F5F5F0',
    'white with black trim': '#F0F0E8',

    // Caribbean variants
    'caribbean': '#024B52',

    // Wine variants (#150: tea berry moved here from Coral)
    'heather wine': '#683040',
    'raspberry coulis': '#A82050',
    'tea berry': '#B03060',

    // Pink variants (#150: hollyhock added; fresh salmon/peony pink→Orange, tender rose→Khaki)
    'hot pink': '#FF1493',
    'watermelon': '#FC6C85',
    'hollyhock': '#C08088',
    'wild rose': '#D890B0',
    'rose violet': '#D16895',
    'bella rosa': '#D8788C',
    'bright rose': '#E0507C',
    'candy pink': '#D03878',
    'blush pink': '#F0B0C0',
    'pink flash': '#E8318A',
    'passion pink': '#E0509C',
    'strawberry pink': '#D86078',
    'rose': '#D090A0',
    'rose pink': '#E090A0',
    'alloy pink': '#E8C0C8',
    'dancing blossom': '#D890B0',
    'slate rose': '#B8929A',
    'fuchsia': '#D0388C',
    'electric pink': '#E0509C',

    // Khaki variants (#150: tender rose moved here from Pink)
    'tender rose': '#C0A088',

    'sandstone': '#C8B090',
    'taupe': '#B09880',
    'brown': '#8B5E3C',
    'chocolate': '#5C3317',

    // Red variants
    'true red': '#C01030',
    'cherries jubilee': '#980040',
    'racing red': '#CC1020',
    'crimson': '#DC143C',
    'cherry red': '#C01830',

    // Aruba Blue variants
    'island blue': '#3888A8',
    'scuba blue': '#5090A8',
    'heather island blue': '#6898B0',

    // Yellow variants (#150: primrose moved here from Orange — see below)
    'sunshine': '#F8D030',
    'citron': '#CBE876',
    'illuminate': '#F0F5C8',
    'lemon drop': '#F0E878',

    // Olive variants (#150: seagrass moved to Sage)
    'olive moss': '#5A7A20',
    'moss': '#6B7050',

    // Green/Mint variants (#150: sea mist moved to Sage)
    'patina green': '#B0E090',
    'mint julep': '#D8F0C8',
    'heather mint julep': '#B8D8B0',
    'cool mint': '#40C878',
    'honeydew': '#D8F0D0',
    'apple green': '#88B850',
    'lime': '#C0E028',
    'acid lime': '#B8E820',
    'apple': '#A8C058',

    // Orange variants (#150: merged Coral into Orange; fresh salmon + peony pink moved here)
    'coral': '#FF7F50',
    'fresh salmon': '#FA8072',
    'deep coral': '#A83850',
    'coral sunset': '#E87060',
    'coral pop': '#FF7F50',
    'living coral': '#F87068',
    'desert coral': '#E8A888',
    'desert flower': '#E8A080',
    'peony pink': '#F0B080',

    // Yellow variants (#150: primrose moved here from Orange)
    'primrose': '#F0D0A0',

    // Sage variants (#150: seagrass + sea mist moved here)
    'seagrass': '#6BA090',
    'sea mist': '#90C8C0',

    // Misc overrides (kept for swatch accuracy, parent group via aliasMap)
    'raspberry': '#C02060',
    'electric purple': '#8B00FF',

    // CBI Cherokee fashion colors (added 2026-05-12, ref pilot #294)
    'azure blue': '#4A90E2',
    'celery green': '#C2D898',
    'crystal beach': '#B8E0E0',
    'cucumber': '#A8C572',
    'espresso': '#4A2C20',
    'papaya juice': '#FFB347',
    'pink essence': '#F8D0DC',
    'pink melon': '#F69BB2',
    'purple freesia': '#A88BC8',
    'soft marine': '#4A6B8A',
    'sparkling jade': '#4FA897',
    'sweet berry': '#C8456D',
    'sweet paprika': '#C84A2C',

    // CBI Dickies pilot fashion colors (added 2026-05-31)
    'apricot orange': '#F4A04A',
    'bronze mist': '#8B6F47',
    'chilled lilac': '#C8B0D6',
    'ciel': '#8FB4D5',
    'dark khaki': '#A89968',
    'deep amethyst': '#6B3B7E',
    'fern green': '#4F7942',
    'ginger glow': '#C8722E',
    'heather blonde wood': '#C8A878',
    'heather clay': '#B08272',
    'mineral blue': '#6A8AA8',
    'moonstone': '#C8C8C0',
    'redwood dust': '#94553E',
    'sea fog': '#C0CFCC',
    'terrain': '#6B7546',
    'vintage blue': '#5A7B95',

    // CBI Jun-1 2026 cohort colors (Sanibel + Cherokee Infinity/WWOU/WWO + Dickies)
    'aloe': '#B4C9A6',
    'azalea': '#E892B0',
    'blue mist': '#B0C4D6',
    'botanical green': '#4A7C44',
    'bright violet': '#8A4ACC',
    'carmine pink': '#C8456D',
    'celadon': '#ACD0B0',
    'dandelion': '#F5D045',
    'electric lavender': '#B888E0',
    'future fuchsia': '#D8408F',
    'gold rush': '#C8A040',
    'heather cranberry': '#9A4A5A',
    'heritage blue': '#4870A0',
    'lime green': '#A8D045',
    'lime time': '#B8DC58',
    'mali-blu': '#4870A8',
    'orange sorbet': '#F4A872',
    'orange sunrise': '#F89048',
    'orchid': '#C588C8',
    'peri': '#7888C8',
    'pink blush': '#F0BCC8',
    'pinkerton': '#E04060',
    'pretty n purple': '#8B5FBF',
    'rapture rose': '#E4607C',
    'sage green': '#A8C09A',
    'shocking pink': '#FF1493',
    'spiced coral': '#E47650',

    // HH + MC pilot cohort colors (added 2026-06-01)
    'acadia green': '#5A7A4A',
    'apricot sorbet': '#F4B080',
    'aurora berryalis': '#B85488',
    'back to the fuschia': '#D040A0',
    'ballet slipper': '#F4C8D0',
    'beyond green': '#4A8050',
    'blue jean baby': '#5A7BA8',
    'blushing peach': '#F4B8A0',
    'capri sea': '#2EA6BC',
    'caramel cafe': '#A07848',
    'carnation pink': '#FF9DB0',
    'cherry wine': '#7A2030',
    'cloud': '#D8DCDA',
    'copa banana': '#F4D848',
    'coral fusion': '#F08070',
    'cyber lime': '#C8E040',
    'cyber violet': '#8050C8',
    'dark chocolate': '#3C2820',
    'dark pine': '#2A4A38',
    'desert cactus': '#788858',
    'desert taupe': '#A08870',
    'digital lavender': '#A088D0',
    'elderberry': '#5A3850',
    'french brown': '#705038',
    'fresh blue': '#80B0D8',
    'galactic purple': '#502878',
    'garnet red': '#8C2030',
    'gumdrop': '#E480A8',
    'heather ash': '#9C9C9C',
    'heather gray': '#A8A8A8',
    'hyper blue': '#3050E0',
    'ice pink': '#F8D0DC',
    'kiwi lime': '#A8C440',
    'lilac': '#C8A0D0',
    'mali-blue shore': '#4070A8',
    'meta mauve': '#A084A0',
    'midsummer gold': '#C49848',
    'mint condition': '#B8E4C0',
    'ocean abyss': '#1A2848',
    'ocean breeze': '#B0D8DC',
    'one in a melon': '#F4886C',
    "papa don't peach": '#F8B080',
    'perfectly pink': '#F490B4',
    'periwinkle': '#A0B0E0',
    'persian violet': '#8068B0',
    'pink pearl': '#F4C8D4',
    'pink popsicle': '#F088B0',
    'pink power': '#E84080',
    'pink punch': '#FF6090',
    'pixel pink': '#FF80AC',
    'plum royale': '#583858',
    'plum violet': '#5C3858',
    'powder puff pink': '#F8DCE4',
    'precious pink': '#F4B0C8',
    'purple surge': '#7848B8',
    'rainwater': '#A8C0D0',
    'raspberry tart': '#C84068',
    'retro lime': '#B0D050',
    'sand dunes': '#D0B898',
    'santa fe tan': '#C8A878',
    'silver stone': '#B4B4B0',
    'solar flare': '#F4A040',
    'spectra blue': '#3870B0',
    'sunray yellow': '#F8E058',
    'surreal green': '#688048',
    'taffy pink': '#F0A0B8',
    'teal tonic': '#3098A0',
    'trade winds': '#80A8C8',
    'true grape': '#5C3868',
    'twilight blue': '#385878',
    'velvet peach': '#F4A088',
    'warm sunrise': '#F89868',
    'wasabi': '#A8B860',
    'white gardenia': '#F8F4EC',

    // CBI Wave 3 cohort colors — CK ACHIEVE + CK ALLURA (added 2026-06-02)
    'aqua cove': '#5BB5C5',
    'green apple': '#88B850',
    'lilac bloom': '#B8A4D8',
    'soft pomegranate': '#C8506A',
    'tropical hibiscus': '#E04068',
    'true blue': '#1850A0',
    'true coral': '#E87060',
    'wild mulberry': '#5B284A',

    // CBI Wave 3 cohort colors — CK IN PURSUIT (added 2026-06-02)
    'butterscotch': '#C88840',
    'cherry pop': '#E03048',
    'retro green': '#7A9858',
    'tropical pink': '#E84080',
    'walnut roast': '#4A2810'
  };

  // ===================================================================
  // MAEVN PRINT PATTERNS — representative hex for swatch display
  // These are patterns/prints, not solid colors. Ideally use swatch
  // images instead of hex, but hex fallback is provided.
  // ===================================================================
  var prints = {
    'abstract wavy': '#D8A880',
    'all heart': '#988070',
    'americana bows': '#B81030',
    'animal bloom': '#D09068',
    'animalia': '#C89868',
    'autumn bloom': '#F0B080',
    'bear-y bear-y': '#D8B890',
    'beautiful bouquet': '#B87860',
    'birds in bloom': '#B8C828',
    'black leopard jacquard': '#1A1A1A',
    'boo crew': '#104080',
    'born to be wild': '#1A1A1A',
    'botanic beauties': '#805840',
    'brain freeze': '#D8B8A8',
    'cheetah': '#1A1A1A',
    'cherries berries': '#C89870',
    'cherry berry lemonade': '#F8F880',
    'coffee break': '#F0B888',
    'coffee love': '#F8C8A8',
    "crushin' hearts": '#F0C0A0',
    'cuddly checkup': '#805848',
    "cup o' pup": '#E0B078',
    'doggy treats': '#F8B888',
    'everbloom': '#A08050',
    'everything nice': '#805840',
    'festive sips': '#004870',
    'flamazing floral': '#D09878',
    'flamingo beach beauties': '#58C0E8',
    'flamingo ho-ho': '#C89070',
    'floral daze': '#D89870',
    'flower child': '#E8B890',
    'forest friends': '#D09878',
    'frosted ornaments': '#D8A080',
    'funny bunnies': '#D0B090',
    'furever friends': '#E82840',
    'furr-ever colorful': '#F8C0A8',
    'gingerbread zen': '#F8D8C8',
    'girls rule': '#D080A0',
    'gnome matter what': '#E8B890',
    'happy flowers': '#D09068',
    'happy panda': '#F8C0A8',
    'have a fabullama 4th': '#E8B898',
    'hawt diggity': '#B89070',
    'hedgehog honey': '#C09060',
    'hello pumpkin!': '#D09068',
    'hello summer': '#E0A880',
    'holiday party': '#705848',
    'hot chicks': '#D89068',
    'keep calm and sparkle on': '#80D0F0',
    'kitties in disguise': '#104080',
    'lily lala': '#C08868',
    'llama momma': '#F87098',
    'love blooms': '#D09068',
    'love notes': '#F8D0B8',
    'love in every paw': '#E8B898',
    'mad about pineapples': '#A89048',
    'midnight garden': '#F04048',
    'midnight poppies': '#A08070',
    'midnight print': '#F0C0A0',
    'morning sunrise': '#D8C068',
    'my boo': '#D09878',
    'mystic': '#C09878',
    'night blooming': '#982028',
    'nurse vibes': '#D0A080',
    'nuts for you': '#E8B890',
    'ombre paws': '#D09878',
    'orchid nights': '#C89870',
    'otterly in love': '#E8C0D8',
    'pastel leopard': '#D09878',
    'pastel prism': '#805840',
    'pawsome ride': '#68C8E8',
    'peace love paws': '#F8B898',
    'peace love and rainbows': '#B08818',
    'picture perfect': '#B0E8E0',
    'pink grapefruit': '#E0B090',
    'pink hope': '#D060A0',
    'pink peacock': '#D84078',
    'pink strength': '#E888B0',
    'plaid paws': '#E8B890',
    'playful friends': '#F0B888',
    'pretty poppies': '#F03070',
    'proud nurse': '#785848',
    'pumpkin madness': '#F0B080',
    'pumpkin spice': '#D09068',
    'quiet savage': '#D8B090',
    'rainbow dreams': '#F8F088',
    'regal paws': '#E8A880',
    'ribbons of hope (pew)': '#F0B898',
    'ribbons of hope': '#F0B898',
    'rosy bloom': '#C89078',
    'safari in pink': '#906850',
    'shower of blossom': '#E8B890',
    'simply bow-tiful': '#F0C0A0',
    'some bunny loves you': '#D0B8A8',
    'sorbet print': '#C83070',
    'splatter paws': '#D09068',
    'spooky squad': '#D89870',
    'spread your wings': '#E8B898',
    'spring blossom': '#D080B0',
    'spring fantasy': '#E0A880',
    'subtle flower': '#988070',
    'sugar skull dreams': '#785848',
    'summer tides': '#3850A8',
    'summertime fun': '#70A898',
    'sunshine blossoms': '#D8C020',
    "surf's up": '#A8E0D0',
    'sweet goodness': '#70B8B8',
    'sweet hydrangeas': '#70B8B8',
    'sweet shades': '#989040',
    'sweet summer': '#F0B0D8',
    "taco 'bout it": '#D09878',
    'tie dye sunrise': '#805840',
    'tiger daze': '#F8C0A8',
    'tree fest': '#C09878',
    'trick-a-saurus': '#C09078',
    'tropical bloom': '#003858',
    'trust your nurse': '#F0B898',
    'twinkle twinkle': '#E8B898',
    'vacay mode': '#1A1A1A',
    'who let the cat out': '#B0D898',
    'wild blossom': '#E0A878',
    'wild pets': '#E8A880',
    'wild roar': '#C89070',
    'wild thing': '#808060',
    'wildflower pop': '#E070A0',
    'xoxo hearts': '#E07090',
    'yummy treats': '#F0B080',
    'camo': '#D8B0A8',
    'best buds': '#88B850',
    'busy bees': '#F8D030',
    'cat nap': '#B0A8C8',
    'coral pop': '#FF7F50',
    'dream blossom': '#D890B0',
    'flying light': '#A0C8E0',
    'heart paws': '#E07090',
    'heroes in bloom': '#4A90D0',
    'positive vibes': '#F8B888',
    "purr-fect treats": '#D090A0',
    'rainbow paws': '#A078C8',
    // White Cross Core Scrub Cap (style 505) print patterns — 2026-05-04
    // Approximated dominant color of each print. Better data source would be
    // per-variant swatch_image metafield (FIGS pattern), but hex covers
    // baseline display until that ships.
    'scarlett': '#C0395D',          // pink/purple/orange floral on black
    'dreams of glory': '#5878A8',   // blue/teal/black floral on white
    'prism passion': '#7050A0',     // multi-color geometric (assumed purple/violet dominant)
    'red buffalo plaid': '#B22222', // red and black plaid
    'leopard inferno': '#C19A6B',   // leopard print orange/tan
    // White Cross STT/CA Wave 2 prints — 2026-05-05
    // Hex computed programmatically by averaging the dominant non-background
    // pixels in each product's variant front image (scripts/stt-image-audit/_compute-dominant-colors.js).
    // Most read as muted browns/grays because the prints sit on neutral fabric
    // bases; better data source would be per-variant swatch images. This is
    // the v1 pass to eliminate the rainbow fallback on 25 PDPs.
    'alpaca sally pewter': '#887668',
    'alpaca sally pink': '#D0ADAF',
    'black/heather pewter': '#55555E',
    'classic stripe': '#C5C5CE',
    'country flowers': '#AF7F7C',
    'cuties': '#DDD6DA',
    'desert snow': '#C99EA0',
    'electric florals': '#5B5C5E',
    'hello world': '#73645F',          // sheet name "Hello World (Print)" → normalize strips "(print)"
    'holly snowmen': '#B9ADAA',
    'moon shadow': '#6E6978',
    'mosaic garden': '#9A98A3',
    'navy/heather pine grove': '#595E7A',
    'nighttime hocus pocus': '#776560',
    'orchid plaid': '#8C7374',
    'polar commute': '#ACB0AC',
    'puppy playdate': '#725F59',
    'slate': '#6C696D',
    'spooky animal fun': '#9E9291',
    'spring in my step': '#926A88',
    'sunshiny day': '#99876E',
    'teckle toques': '#674F3E',
    // Raw color codes that ended up in variant.option1 because the STT sheet
    // used "Print: XXX" placeholder names instead of friendly names. These
    // entries match the literal current variant value; once option1 is
    // updated to friendly names, these can be removed.
    'print: hyt': '#B3A8A4',
    'print: lmst': '#9E9DC6',
    'print: pplv': '#938785',
    'print: spkt': '#8C7B7D',
    // Wave 3 additions — 2026-05-05. Hex computed via dominant-non-white pixel
    // average from each variant's front image. Closes rainbow-swatch fallback
    // on remaining White Cross prints + heathered solid colors.
    'polar plunge': '#C2CAC8',
    'psychedelic butterfly': '#787378',
    "santa's helpers": '#BDB9B7',
    'spooky lollipops': '#C2BFBC',
    'too cool dental': '#56586F',
    'mauve shadows': '#B89EA7',
    'violet tulip': '#A296BC',
    'heather coral sunset': '#E5BDB7',
    'sweet poppy': '#D8B7C6',
    // Wave 4 solid colors moved to overrides on 2026-05-10 (see overrides block).
    // Wave 5 additions — 2026-05-08. Print + Sanibel hex computed from Front
    // Image dominant-non-white pixel via scripts/ca-3pl/_compute-wave5-hex.js.
    'alpaca sally - pink': '#E4BEC6',
    'alpaca sally - pewter': '#8D7B6D',
    'boston holiday': '#635043',
    'camo jr': '#74768D',
    // Raw vendor color codes in variant.option1 for Smitten Sanibel SA618
    // sub-styles. Same pattern as the 'print: xxx' entries above; aliases to
    // the existing friendly-name hex until option1 is renamed.
    'bhd': '#635043',
    'cmjr': '#74768D'
  };

  // Light colors that need a visible border
  var lightColors = [
    '#F0F0E8', '#F5F5F0', '#E8E8E0', '#D8F0D0', '#F8F880', '#F0E878',
    '#F8D8C8', '#F8D030', '#F0C0A0', '#F8C8A8', '#F8C0A8', '#F0B0D8',
    '#F8F088', '#F8D0B8', '#C0C0C0', '#B8B8B8', '#D0B8A8', '#D0B090',
    '#E8B8A0', '#B0E8E0', '#A8E0D0', '#B0E090', '#D4B800', '#D4C840',
    '#F0D870', '#F0E878', '#E8A080', '#F0D0A0', '#50C880', '#48C8E0'
  ];

  // Print pattern -> family group (alias -> master group name). Source: data/color-registry.json.
  // Auto-generated by scripts/build-color-registry.js — DO NOT edit by hand.
  // Mirrors the |alias=GROUP| pairs in snippets/_color-aliases.liquid so Liquid + JS classify identically.
  var printGroups = {
    'abstract wavy': 'Khaki',
    'all heart': 'Khaki',
    'alpaca sally - pewter': 'Pewter',
    'alpaca sally - pink': 'Pink',
    'alpaca sally pewter': 'Pewter',
    'alpaca sally pink': 'Pink',
    'americana bows': 'Red',
    'animal bloom': 'Khaki',
    'animalia': 'Khaki',
    'autumn bloom': 'Orange',
    'bear-y bear-y': 'Khaki',
    'beautiful bouquet': 'Khaki',
    'best buds': 'Green',
    'birds in bloom': 'Yellow',
    'black leopard jacquard': 'Black',
    'black/heather pewter': 'Pewter',
    'boo crew': 'Navy',
    'born to be wild': 'Black',
    'boston holiday': 'Khaki',
    'botanic beauties': 'Khaki',
    'brain freeze': 'Khaki',
    'busy bees': 'Yellow',
    'camo': 'Khaki',
    'camo jr': 'Pewter',
    'cat nap': 'Lavender',
    'cheetah': 'Black',
    'cherries berries': 'Khaki',
    'cherry berry lemonade': 'Yellow',
    'classic stripe': 'Pewter',
    'coffee break': 'Orange',
    'coffee love': 'Orange',
    'country flowers': 'Khaki',
    "crushin' hearts": 'Orange',
    'cuddly checkup': 'Khaki',
    "cup o' pup": 'Khaki',
    'cuties': 'Pewter',
    'desert snow': 'Khaki',
    'doggy treats': 'Orange',
    'dream blossom': 'Pink',
    'dreams of glory': 'Royal Blue',
    'electric florals': 'Pewter',
    'everbloom': 'Khaki',
    'everything nice': 'Khaki',
    'festive sips': 'Navy',
    'flamazing floral': 'Khaki',
    'flamingo beach beauties': 'Sky Blue',
    'flamingo ho-ho': 'Khaki',
    'floral daze': 'Khaki',
    'flower child': 'Khaki',
    'flying light': 'Sky Blue',
    'forest friends': 'Khaki',
    'frosted ornaments': 'Khaki',
    'funny bunnies': 'Khaki',
    'furever friends': 'Red',
    'furr-ever colorful': 'Orange',
    'gingerbread zen': 'Orange',
    'girls rule': 'Pink',
    'gnome matter what': 'Khaki',
    'happy flowers': 'Khaki',
    'happy panda': 'Orange',
    'have a fabullama 4th': 'Khaki',
    'hawt diggity': 'Khaki',
    'heart paws': 'Pink',
    'heather coral sunset': 'Orange',
    'hedgehog honey': 'Khaki',
    'hello pumpkin!': 'Khaki',
    'hello summer': 'Khaki',
    'hello world': 'Khaki',
    'heroes in bloom': 'Royal Blue',
    'holiday party': 'Khaki',
    'holly snowmen': 'Pewter',
    'hot chicks': 'Khaki',
    'keep calm and sparkle on': 'Sky Blue',
    'kitties in disguise': 'Navy',
    'leopard inferno': 'Khaki',
    'lily lala': 'Khaki',
    'llama momma': 'Pink',
    'love blooms': 'Khaki',
    'love in every paw': 'Khaki',
    'love notes': 'Orange',
    'mad about pineapples': 'Khaki',
    'mauve shadows': 'Pink',
    'midnight garden': 'Red',
    'midnight poppies': 'Khaki',
    'midnight print': 'Orange',
    'moon shadow': 'Pewter',
    'morning sunrise': 'Yellow',
    'mosaic garden': 'Pewter',
    'my boo': 'Khaki',
    'mystic': 'Khaki',
    'navy/heather pine grove': 'Navy',
    'night blooming': 'Red',
    'nighttime hocus pocus': 'Khaki',
    'nurse vibes': 'Khaki',
    'nuts for you': 'Khaki',
    'ombre paws': 'Khaki',
    'orchid nights': 'Khaki',
    'orchid plaid': 'Khaki',
    'otterly in love': 'Pink',
    'pastel leopard': 'Khaki',
    'pastel prism': 'Khaki',
    'pawsome ride': 'Sky Blue',
    'peace love and rainbows': 'Khaki',
    'peace love paws': 'Orange',
    'picture perfect': 'Aqua Blue',
    'pink grapefruit': 'Pink',
    'pink hope': 'Pink',
    'pink peacock': 'Pink',
    'pink strength': 'Pink',
    'plaid paws': 'Khaki',
    'playful friends': 'Orange',
    'polar commute': 'Pewter',
    'polar plunge': 'Pewter',
    'positive vibes': 'Orange',
    'pretty poppies': 'Pink',
    'print: hyt': 'Pewter',
    'print: lmst': 'Lavender',
    'print: pplv': 'Khaki',
    'print: spkt': 'Khaki',
    'prism passion': 'Eggplant',
    'proud nurse': 'Khaki',
    'psychedelic butterfly': 'Pewter',
    'pumpkin madness': 'Orange',
    'pumpkin spice': 'Khaki',
    'puppy playdate': 'Khaki',
    'purr-fect treats': 'Pink',
    'quiet savage': 'Khaki',
    'rainbow dreams': 'Yellow',
    'rainbow paws': 'Lavender',
    'red buffalo plaid': 'Red',
    'regal paws': 'Orange',
    'ribbons of hope': 'Orange',
    'ribbons of hope (pew)': 'Orange',
    'rosy bloom': 'Khaki',
    'safari in pink': 'Khaki',
    "santa's helpers": 'Pewter',
    'scarlett': 'Pink',
    'shower of blossom': 'Khaki',
    'simply bow-tiful': 'Orange',
    'slate': 'Pewter',
    'some bunny loves you': 'Khaki',
    'sorbet print': 'Pink',
    'splatter paws': 'Khaki',
    'spooky animal fun': 'Khaki',
    'spooky lollipops': 'Pewter',
    'spooky squad': 'Khaki',
    'spread your wings': 'Khaki',
    'spring blossom': 'Pink',
    'spring fantasy': 'Khaki',
    'spring in my step': 'Pink',
    'subtle flower': 'Khaki',
    'sugar skull dreams': 'Khaki',
    'summer tides': 'Royal Blue',
    'summertime fun': 'Sage',
    'sunshine blossoms': 'Yellow',
    'sunshiny day': 'Khaki',
    "surf's up": 'Aqua Blue',
    'sweet goodness': 'Aqua Blue',
    'sweet hydrangeas': 'Aqua Blue',
    'sweet poppy': 'Pink',
    'sweet shades': 'Olive',
    'sweet summer': 'Pink',
    "taco 'bout it": 'Khaki',
    'teckle toques': 'Khaki',
    'tie dye sunrise': 'Khaki',
    'tiger daze': 'Orange',
    'too cool dental': 'Pewter',
    'tree fest': 'Khaki',
    'trick-a-saurus': 'Khaki',
    'tropical bloom': 'Navy',
    'trust your nurse': 'Orange',
    'twinkle twinkle': 'Khaki',
    'vacay mode': 'Black',
    'violet tulip': 'Lavender',
    'who let the cat out': 'Green',
    'wild blossom': 'Khaki',
    'wild pets': 'Orange',
    'wild roar': 'Khaki',
    'wild thing': 'Olive',
    'wildflower pop': 'Pink',
    'xoxo hearts': 'Pink',
    'yummy treats': 'Orange'
  };

  function normalize(name) {
    if (!name) return '';
    // Lowercase, trim, strip vendor codes in parens like "(BKM)", "(CRB)"
    return name.toLowerCase().trim().replace(/\s*\([^)]*\)\s*$/, '');
  }

  function isLight(hex) {
    if (!hex) return false;
    if (lightColors.indexOf(hex) >= 0) return true;
    // Calculate luminance
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    return (r * 0.299 + g * 0.587 + b * 0.114) > 200;
  }

  function getHex(colorName) {
    var key = normalize(colorName);
    if (!key) return undefined;

    // 1. Check individual overrides first (most specific)
    if (overrides.hasOwnProperty(key)) return overrides[key];

    // 2. Check alias → master group hex
    if (aliasMap.hasOwnProperty(key)) return aliasMap[key];

    // 3. Check print patterns
    if (prints.hasOwnProperty(key)) return prints[key];

    // 4. Fallback: convert hyphens to spaces (for handleized names like "island-blue")
    var spaced = key.replace(/-/g, ' ');
    if (spaced !== key) {
      if (overrides.hasOwnProperty(spaced)) return overrides[spaced];
      if (aliasMap.hasOwnProperty(spaced)) return aliasMap[spaced];
      if (prints.hasOwnProperty(spaced)) return prints[spaced];
    }

    return undefined; // not found
  }

  // Conic-gradient used for "Prints" swatches in nav + filter + color-rail.
  // Single source of truth — applyAll, renderFilters, renderColorRail all reference this.
  var PRINTS_GRADIENT = 'conic-gradient(from 45deg, #F08080, #FFD700, #87CEEB, #98FB98, #FFB6C1, #F08080)';

  function applyAll() {
    var dots = document.querySelectorAll('[data-color-name]');
    for (var i = 0; i < dots.length; i++) {
      var dot = dots[i];
      var name = dot.getAttribute('data-color-name');
      var normalized = normalize(name);
      // Special-case: "Prints" / "Print" → conic-gradient (the same one used
      // by the in-page color filter and the color-rail).
      if (normalized === 'prints' || normalized === 'print') {
        dot.style.backgroundColor = '';
        dot.style.backgroundImage = PRINTS_GRADIENT;
        continue;
      }
      var hex = getHex(name);
      // Read data-swatch-img (PDP dots) OR data-image-url (product-card dots).
      // Cards emit the colorway photo as data-image-url; without this fallback
      // an unmapped multi-color/print name (e.g. sock "black/vivid orange",
      // character prints) skips the image and hits the rainbow gradient below.
      var swatchImg = dot.getAttribute('data-swatch-img') || dot.getAttribute('data-image-url');
      // Named prints: show the actual print from the colourway photo instead of an averaged hex.
      if (swatchImg && printGroups && Object.prototype.hasOwnProperty.call(printGroups, normalized)) {
        dot.style.backgroundColor = '';
        dot.style.backgroundImage = 'url(' + swatchImg + ')';
        var _top = dot.getAttribute('data-swatch-focus') === 'top';
        dot.style.backgroundSize = _top ? '650%' : '260%';
        dot.style.backgroundPosition = _top ? '47% 5%' : 'center 38%';
        dot.style.backgroundRepeat = 'no-repeat';
        continue;
      }

      // NOTE: use backgroundColor / backgroundImage (not `background` shorthand)
      // so the CSS `background-clip: content-box` on product-card dots is
      // preserved. Setting `background` shorthand resets background-clip to
      // border-box, which makes the color bleed into the border area used for
      // the PDP-style active ring.
      // Fix #146: border logic applies to PDP dots AND filter swatches
      var needsBorder = dot.classList.contains('s-pdp__color-dot') || dot.classList.contains('s-filter__color-swatch');

      // Priority: known hex (clean solid circle) > swatch image (print patterns
      // fall back to product image) > rainbow gradient (last resort, indicates
      // missing data). Updated 2026-05-04: image swatch was originally
      // top-priority, but Liquid now emits `data-swatch-img` on every PDP color
      // dot, so hex must win first to keep the clean look on known solid colors.
      // Print/pattern colors (Scarlett, Dreams Of Glory, etc.) fall through to
      // image swatch, which shows the actual print rather than rainbow.
      if (hex && hex !== null) {
        dot.style.backgroundColor = hex;
        dot.style.backgroundImage = 'none';
        if (isLight(hex) && needsBorder) {
          dot.style.border = '1px solid #ddd';
        }
      } else if (swatchImg) {
        dot.style.backgroundImage = 'url(' + swatchImg + ')';
        dot.style.backgroundSize = 'cover';
        dot.style.backgroundPosition = 'center';
        if (needsBorder) {
          dot.style.border = '1px solid #ddd';
        }
      } else {
        // Fallback — should never appear if alt color is mapped or has image
        dot.style.backgroundImage = 'linear-gradient(135deg, #FF6B6B, #4ECDC4, #FFE66D, #A78BFA)';
        if (needsBorder) {
          dot.style.border = 'none';
        }
      }
    }
  }

  // ===================================================================
  // RENDER FILTERS — #151: auto-build color filter checkboxes from
  // masterGroups so Liquid only needs a placeholder <div>.
  // Generates the same HTML that was previously hardcoded in Liquid.
  // ===================================================================
  function renderFilters() {
    var targets = document.querySelectorAll('[data-color-filter-target]');
    if (!targets.length) return;

    var html = '';
    for (var g = 0; g < masterGroups.length; g++) {
      var group = masterGroups[g];
      // Short label: drop " Blue"/" Green" suffix for compact display
      // e.g., "Ceil Blue" → "Ceil", "Hunter Green" → "Hunter"
      var label = group.name.replace(/ Blue$/, '').replace(/ Green$/, '');

      html += '<label class="s-filter__color-option" title="' + group.name + '">'
        + '<input type="checkbox" name="filter_color" value="' + group.name + '">'
        + '<span class="s-filter__color-swatch" data-color-name="' + group.name + '"></span>'
        + '<span class="s-filter__color-label">' + label + '</span>'
        + '</label>';
    }
    // Print / Pattern entry (not a master group)
    html += '<label class="s-filter__color-option" title="Print / Pattern">'
      + '<input type="checkbox" name="filter_color" value="Print">'
      + '<span class="s-filter__color-swatch s-filter__color-swatch--print" '
      + 'style="background:conic-gradient(from 45deg, #F08080, #FFD700, #87CEEB, #98FB98, #FFB6C1, #F08080)"></span>'
      + '<span class="s-filter__color-label">Print</span>'
      + '</label>';

    for (var t = 0; t < targets.length; t++) {
      targets[t].innerHTML = html;
    }

    // Apply swatch colors after rendering
    applyAll();

    // #296 T1.6: notify the desktop filter / mobile drawer that color options
    // are now in the DOM. Without this, a drawer opened before renderFilters()
    // runs (slow connection) shows an empty color section.
    try {
      document.dispatchEvent(new CustomEvent('ap:filter-color-ready'));
    } catch (e) { /* IE/old browser — drawer will catch up on next open */ }
  }

  // ===================================================================
  // RENDER COLOR RAIL — #164: auto-build homepage "Shop by Color" rail
  // from masterGroups so it stays in sync with the master color map.
  // Prints swatch appended at the end.
  // ===================================================================
  function renderColorRail() {
    var target = document.querySelector('[data-color-rail-target]');
    if (!target) return;

    var html = '';
    for (var g = 0; g < masterGroups.length; g++) {
      var group = masterGroups[g];
      if (!group.collection) continue;
      var border = isLight(group.hex) ? 'border:1px solid #ddd;' : '';
      html += '<a href="' + group.collection + '" class="s-color-rail__item">'
        + '<div class="s-color-rail__swatch" style="background:' + group.hex + ';' + border + '"></div>'
        + '<span class="s-color-rail__label">' + group.name + '</span>'
        + '</a>';
    }
    // Prints swatch at the end — use custom image if available via Liquid asset_url
    var printsImg = target.getAttribute('data-prints-image');
    var printsBg = printsImg
      ? 'background:url(\'' + printsImg + '\') center/cover;'
      : 'background:conic-gradient(from 45deg, #F08080, #FFD700, #87CEEB, #98FB98, #FFB6C1, #F08080);';
    html += '<a href="/collections/prints" class="s-color-rail__item">'
      + '<div class="s-color-rail__swatch" style="' + printsBg + '"></div>'
      + '<span class="s-color-rail__label">Prints</span>'
      + '</a>';

    target.innerHTML = html;
  }

  // ===================================================================
  // RENDER NAV COLORS — #151: auto-build header mega-menu color grid
  // and mobile drawer color links from masterGroups.
  // Only groups with a collection URL are included.
  // ===================================================================
  function renderNavColors() {
    // Desktop mega-menu color grid
    var desktopGrid = document.querySelector('[data-nav-color-grid]');
    if (desktopGrid) {
      var html = '';
      var count = 0;
      for (var g = 0; g < masterGroups.length; g++) {
        var group = masterGroups[g];
        if (!group.collection) continue;
        count++;
        html += '<a href="' + group.collection + '" class="s-header__color-item">'
          + '<span class="s-header__mega-swatch" data-color-name="' + group.name + '"></span>'
          + '<span class="s-header__color-name">' + group.name + '</span>'
          + '</a>';
      }
      desktopGrid.innerHTML = html;
      // Update "View All N Colors" count
      var countEl = document.querySelector('[data-nav-color-count]');
      if (countEl) countEl.textContent = count;
    }

    // Mobile drawer color links
    var mobileTarget = document.querySelector('[data-nav-color-mobile]');
    if (mobileTarget) {
      var mhtml = '';
      for (var m = 0; m < masterGroups.length; m++) {
        var mg = masterGroups[m];
        if (!mg.collection) continue;
        mhtml += '<a href="' + mg.collection + '" class="s-header__drawer-sub-link s-header__drawer-sub-link--color">'
          + '<span class="s-header__drawer-color-swatch" data-color-name="' + mg.name + '"></span>'
          + '<span class="s-header__drawer-color-name">' + mg.name + '</span>'
          + '</a>';
      }
      mobileTarget.innerHTML = mhtml;
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      renderFilters();
      renderNavColors();
      renderColorRail();
      applyAll();
    });
  } else {
    renderFilters();
    renderNavColors();
    renderColorRail();
    applyAll();
  }

  // ===================================================================
  // resolveGroup(name) — JS companion to snippets/resolve-color-group.liquid.
  // Returns the canonical master-group name (e.g. "Hunter Green") for any
  // alias, override key, or print pattern. Returns '' for unmapped /
  // ignored inputs. Mirrors the Liquid resolver's three-pass strategy:
  //   1. full input  2. split(' - ')[0]  3. split(' ')[0]
  // ===================================================================
  // Build alias→groupName lookup once (analogous to aliasMap, but value is
  // the master group's display name rather than its hex).
  var aliasGroupMap = {};
  for (var ag = 0; ag < masterGroups.length; ag++) {
    var grp = masterGroups[ag];
    for (var ai = 0; ai < grp.aliases.length; ai++) {
      aliasGroupMap[grp.aliases[ai]] = grp.name;
    }
  }

  // Alt-text artifacts that aren't colors (mirror data/color-registry.json `ignored`).
  var ignoredAliases = {
    detail: 1, standard: 1, front: 1, side: 1, back: 1,
    'n/a': 1, tbd: 1, 'default': 1,
    '01 bl': 1, ww: 1, dwhl: 1, phbn: 1, '16 nn': 1
  };

  function resolveGroup(name) {
    if (!name) return '';
    var lower = String(name).toLowerCase().trim();
    if (!lower || ignoredAliases.hasOwnProperty(lower)) return '';
    var stripped = lower.replace(/\s*\([^)]*\)\s*$/, '');

    function tryKey(k) {
      if (!k) return null;
      if (aliasGroupMap.hasOwnProperty(k)) return aliasGroupMap[k];
      // Print patterns are not in masterGroups.aliases but live in `prints`.
      // Resolve print → its master group via a short lookup table generated
      // at registry-build time would be ideal; for now we treat prints as
      // their own implicit group via aliasMap absence (returns hex but no
      // group). If needed, expand here later.
      return null;
    }

    var hit = tryKey(stripped) || tryKey(lower);
    if (hit) return hit;

    var seg = lower.split(' - ')[0].trim().replace(/\s*\([^)]*\)\s*$/, '');
    hit = tryKey(seg);
    if (hit) return hit;

    var word = lower.split(' ')[0].trim();
    hit = tryKey(word);
    if (hit) return hit;

    return '';
  }

  return {
    getHex: getHex,
    isLight: isLight,
    normalize: normalize,
    resolveGroup: resolveGroup,
    applyAll: applyAll,
    renderFilters: renderFilters,
    renderNavColors: renderNavColors,
    renderColorRail: renderColorRail,
    printGroups: printGroups,
    masterGroups: masterGroups
  };
})();


